import { MINCOL } from "../../../constants/const";

export const zvHeader = [
    {
        accessor: 'id',
        Header: 'id'
    },

    {
        accessor: 'name',
        Header: 'Name des Zweckverbandes',
        width: '28em'
    },

    {
        accessor: 'kurz',
        Header: 'Abkürzung',
        width: MINCOL
    }
]

export const zvForm = [

    {
        accessor: 'name',
        Header: 'Bezeichnung',
        required: true
    },

    {
        accessor: 'kurz',
        Header: 'Abkürzung',
        required: true
    },

    {
        accessor: 'kommentar',
        Header: 'Kommentar',
        required: false
    }
]
// export const zvHeader = [
//     {accessor: 'id',
//     Header: 'id',
//     Cell: EditableCell}, 

//     {accessor: 'name', 
//     Header: 'Name des Zweckverbandes',
//     Cell: EditableCell}, 

//     {accessor: 'kurz', 
//     Header: 'Abkürzung',
//     Cell: EditableCell}
// ]

export const zvInputs = ['name', 'kurz'];